import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useEffect,useState } from 'react';


export function ImageLoader(props: { source: string }) {
    const { source } = props;
    const [imageLoaded, setImageLoaded] = useState(false);

    const preloadImage = (src: string) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    };
    
    

    useEffect(() => {
        let didRun = true;

        if (didRun) {
          preloadImage(source).then(() => setImageLoaded(true));
        }

        return () => {
          didRun = false;
          setImageLoaded(didRun);
        };
        
    }, [source]);

   
    if (imageLoaded) {
      return <img src={source} alt='Image' className="w-full h-auto rounded-sm"/>;
    }
    return <Skeleton width="100%" height="100%" className="flex-1 w-full h-full aspect-video"/>;

}

